import { useState } from "react";
import { useVoiceSettings } from "../useVoiceSettings";
import InputComponent from "V2.0/components/InputComponent";
import { Button } from "V2.0/common/button";

export default function CallDurationSettings(props) {
  const {
    websocketMaxOpenTime,
    workspaceId,
    assistantId,
    syncAssistant,
    locked,
  } = props;

  const { updateVoiceSettings } = useVoiceSettings({
    syncAssistant,
    workspaceId,
    assistantId,
  });

  const [settings, setSettings] = useState({
    websocketMaxOpenTime,
  });
  const [loading, setLoading] = useState(false);

  function handleUpdate(data) {
    setSettings({
      websocketMaxOpenTime: data,
    });
  }

  function handleSave() {
    updateVoiceSettings(settings);
    // setLoading(false);
  }

  return (
    <div className="flex flex-col border rounded-lg w-3/5 min-w-[600px] m-4">
      <div className="p-4 bg-gray-50 rounded-t-lg px-6">
        <p className="text-base font-semibold text-gray-900">Call Duration</p>
        <p className="text-sm mt-1 text-gray-500">
          Set a time limit for calls. Once reached, the call will end on its
          own.
        </p>
      </div>
      <div className="grid grid-cols-4 p-4 w-full px-6">
        <div className="col-span-4 xl:col-span-2 w-full">
          <InputComponent
            type="number"
            label="Maximum Duration (Seconds)"
            value={settings.websocketMaxOpenTime}
            onChange={(e) => handleUpdate(e.target.value)}
            disabled={locked}
          />
        </div>
      </div>
      <div className="bg-gray-50 rounded-b-lg px-4 py-3 text-right">
        {!locked && (
          <Button
            loading={loading}
            onClick={handleSave}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
}
